import Rails from "@rails/ujs";
import { Chart, registerables } from 'chart.js';

require.context('../images', true)

// Register Chart.js components
Chart.register(...registerables);

// Make Chart available globally for inline scripts
window.Chart = Chart;

Rails.start();